module.exports = __webpack_public_path__ + "static/media/Sero Image PRIME 85-1 & PRIME 124-2 - 1340 x 650.09da4d46.jpg";